import { useCallback, useMemo } from "react";
import { useAppDispatch, useRootState } from "./index";
import { bindActionCreators } from "redux";
import {
  trunkAdminOTPLogin,
  trunkAdminSendOTPEMail,
  trunkAdminSessionLogin,
  trunkAdminSessionNew,
  trunkAdminUpdateNewPassword,
} from "../store/admin/adminLogin";

const useAdminLoginStore = () => {
  const adminLoginState = useRootState((state) => state.adminLoginStore);

  const dispatch = useAppDispatch();

  const boundAdminSessionNew = useCallback(
    () => dispatch(trunkAdminSessionNew()).then(),
    [dispatch]
  );
  const boundAdminSessionLogin = useMemo(
    () => bindActionCreators(trunkAdminSessionLogin, dispatch),
    [dispatch]
  );
  const boundAdminSendOTPEMail = useMemo(
    () => bindActionCreators(trunkAdminSendOTPEMail, dispatch),
    [dispatch]
  );
  const boundAdminOTPLogin = useMemo(
    () => bindActionCreators(trunkAdminOTPLogin, dispatch),
    [dispatch]
  );
  const boundAdminUpdateNewPassword = useMemo(
    () => bindActionCreators(trunkAdminUpdateNewPassword, dispatch),
    [dispatch]
  );

  return {
    adminLoginState,
    adminSessionNew: boundAdminSessionNew,
    adminSessionLogin: boundAdminSessionLogin,
    adminSendOTPEMail: boundAdminSendOTPEMail,
    adminOTPLogin: boundAdminOTPLogin,
    adminUpdateNewPassword: boundAdminUpdateNewPassword,
  };
};

export default useAdminLoginStore;
